import type { ProductItem } from "@repo/apis/bag";

export type SellerGroup = {
  sourceId: string | null;
  sourceDescription: string | null;
  items: ProductItem[];
};

export const groupBagItemsBySeller = (items: ProductItem[]): SellerGroup[] => {
  const standardGroup: SellerGroup = {
    sourceId: null,
    sourceDescription: null,
    items: [],
  };

  const flexiGroups = new Map<string, SellerGroup>();

  for (const item of items) {
    if (!item.source?.id) {
      standardGroup.items.push(item);
    } else {
      const existing = flexiGroups.get(item.source.id);
      if (existing) {
        existing.items.push(item);
      } else {
        flexiGroups.set(item.source.id, {
          sourceId: item.source.id,
          sourceDescription: item.source.description,
          items: [item],
        });
      }
    }
  }

  const result: SellerGroup[] = [];

  if (standardGroup.items.length > 0) {
    result.push(standardGroup);
  }

  for (const group of flexiGroups.values()) {
    result.push(group);
  }

  return result;
};
